:host {
  display: flex;
  height: 1px;
  background-color: #99999980;
  margin-block: 2px;
}